module.exports = __webpack_public_path__ + "assets/tankaLarge.8a4c01ba.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/logos/tankaLarge.png
// module id = 275
// module chunks = 1